module.exports = __webpack_public_path__ + "img/tonmetier.5fe7a122.png";